import { showFormDialog } from '@juvare/common-form-ui/showFormDialog';
import { handleErrorSnackbar, showAlertSnackbar } from '@juvare/common-web-ui/SnackbarHelper';
import { onFileDuplicateNotExists } from '../../features/file-manager';
export function showCreateDirectoryDialog(params) {
    showFormDialog({
        title: params.t('documentPanel.createFolder'),
        fullWidth: params.mobileScreen,
        config: {
            type: 'form',
            children: [
                {
                    type: 'form.text',
                    key: 'name',
                    label: 'Name',
                    validate: {
                        required: true,
                    },
                },
                {
                    type: 'form.text',
                    key: 'summary',
                    label: 'Summary',
                    multiline: true,
                    rows: 4,
                },
            ],
        },
        submitLabel: 'Create',
        onSubmit: (data) => {
            onFileDuplicateNotExists({ name: data.name, parentId: params.parentId }, params.storage, () => {
                params.storage
                    .createDirectory({
                    name: data.name,
                    parentId: params.parentId,
                    ownerId: params.ownerId,
                    additionalData: { summary: data.summary },
                })
                    .then((response) => {
                    showAlertSnackbar({
                        horizontalPosition: 'center',
                        type: 'success',
                        verticalPosition: 'bottom',
                        autoHideDuration: 2000,
                        message: params.t('createFolderDialog.folderCreatedSnackbar'),
                    });
                    params.onSuccess(response);
                });
            }).catch(handleErrorSnackbar);
        },
    });
}
